import { isAuthenticated } from '../utils/authHelper';
import React, { Component, Fragment } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import ReactTable from 'react-table';
import matchSorter from 'match-sorter';
import 'react-table/react-table.css';
import moment from 'moment';
import { browserHistory } from 'react-router';

import {
  getAllBusinessUnits,
  getBusinessUnitRequests,
  createBusinessUnitRequest,
  updateBusinessUnitRequest,
  editPendingBURequest,
  getPendingRequestForBU,
  approveBusinessUnitRequest,
  rejectBusinessUnitRequest
} from '../utils/BusinessUnitApiUtils';
import BusinessUnitRequestTimeline from './BusinessUnitRequestTimeline';
import Header from './Header';
import userdata from '../config/jwt_token';

import {
  Button, Tabs, Tab, Dialog, DialogTitle, DialogContent,
  DialogActions, TextField, Typography, Paper, Switch,
  FormControlLabel, Snackbar
} from '@material-ui/core';
import CircularProgress from 'material-ui/CircularProgress';

import EditIcon from '@material-ui/icons/Edit';
import HistoryIcon from '@material-ui/icons/History';
import AddIcon from '@material-ui/icons/Add';
import { businessUnitMap } from '../constants/paymentStatus';

class BusinessUnitManagement extends Component {
  constructor(props) {
    super(props);
    if (!isAuthenticated()) {
      browserHistory.push('/');
    }
    this.state = {
      tabValue: 0,
      businessUnits: [],
      requests: [],
      loading: false,

      requestDialogOpen: false,
      approvalDialogOpen: false,
      rejectionDialogOpen: false,
      timelineOpen: false,

      selectedRequest: null,
      formData: {
        business_unit_id: null,
        label: '',
        value: '',
        bank_account_number: '',
        is_bu_wise_buf: false,
        remarks: ''
      },
      approvalRemarks: '',
      rejectionRemarks: '',

      isEditingPendingRequest: false,
      pendingRequestId: null,

      snackOpen: false,
      snackText: '',

      role: userdata ? userdata.role : ''
    };
  }

  componentDidMount() {
    this.fetchInitialData();
  }

  fetchInitialData = async () => {
    this.setState({ loading: true });
    try {
      await this.fetchBusinessUnits();
      await this.fetchRequests();
      this.setState({ loading: false });
    } catch (err) {
      console.error('Error fetching initial data', err);
      this.setState({ loading: false });
    }
  };

  showSnack = (message) => {
    this.setState({ snackOpen: true, snackText: message });
  };

  handleCloseSnack = () => {
    this.setState({ snackOpen: false });
  };

  fetchBusinessUnits = async () => {
    try {
      const res = await getAllBusinessUnits();
      if (res.status === 'success' && res.data && res.data.length > 0) {
        this.setState({ businessUnits: res.data });
      } else {
        this.setState({ businessUnits: [] });
      }
    } catch (err) {
      console.error(err);
    }
  };

  fetchRequests = async () => {
    try {
      const res = await getBusinessUnitRequests('all');
      if (res.status === 'success') {
        this.setState({ requests: res.data });
      }
    } catch (err) {
      console.error(err);
    }
  };

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
    if (newValue === 0) {
      this.fetchBusinessUnits();
    } else {
      this.fetchRequests();
    }
  };

  openCreateRequestDialog = () => {
    this.setState({
      requestDialogOpen: true,
      formData: { business_unit_id: null, label: '', value: '', bank_account_number: '', is_bu_wise_buf: false, remarks: '' },
      isEditingPendingRequest: false,
      pendingRequestId: null
    });
  };

  openUpdateRequestDialog = async (bu) => {
    this.setState({ loading: true });

    try {
      const pendingRes = await getPendingRequestForBU({ business_unit_id: bu.id });

      if (pendingRes.hasPending && pendingRes.data) {
        const pendingRequest = pendingRes.data;
        this.setState({
          requestDialogOpen: true,
          formData: {
            business_unit_id: bu.id,
            label: pendingRequest.label,
            value: pendingRequest.value,
            bank_account_number: pendingRequest.bank_account_number || '',
            is_bu_wise_buf: pendingRequest.is_bu_wise_buf || false,
            remarks: pendingRequest.remarks || ''
          },
          isEditingPendingRequest: true,
          pendingRequestId: pendingRequest.request_id,
          loading: false
        });
        this.showSnack('Editing existing pending request for this business unit');
      } else {
        this.setState({
          requestDialogOpen: true,
          formData: {
            business_unit_id: bu.id,
            label: bu.label,
            value: bu.value,
            bank_account_number: bu.bank_account_number || '',
            is_bu_wise_buf: bu.is_bu_wise_buf || false,
            remarks: ''
          },
          isEditingPendingRequest: false,
          pendingRequestId: null,
          loading: false
        });
      }
    } catch (err) {
      console.error('Error checking pending request', err);
      this.setState({
        requestDialogOpen: true,
        formData: {
          business_unit_id: bu.id,
          label: bu.label,
          value: bu.value,
          bank_account_number: bu.bank_account_number || '',
          is_bu_wise_buf: bu.is_bu_wise_buf || false,
          remarks: ''
        },
        isEditingPendingRequest: false,
        pendingRequestId: null,
        loading: false
      });
    }
  };

  handleRequestSubmit = async () => {
    const { formData, isEditingPendingRequest, pendingRequestId } = this.state;

    if (!formData.label.trim()) {
      this.showSnack('Label is required');
      return;
    }

    if (!formData.value.trim()) {
      this.showSnack('Value is required');
      return;
    }

    if (formData.is_bu_wise_buf && !formData.bank_account_number.trim()) {
      this.showSnack('Bank account number is required when BU-wise BUF is enabled');
      return;
    }

    this.setState({ loading: true });
    try {
      let res;
      if (isEditingPendingRequest && pendingRequestId) {
        res = await editPendingBURequest({ ...formData, request_id: pendingRequestId });
      } else if (formData.business_unit_id) {
        res = await updateBusinessUnitRequest(formData);
      } else {
        res = await createBusinessUnitRequest(formData);
      }

      if (res.status === 'success') {
        this.setState({
          requestDialogOpen: false,
          loading: false,
          isEditingPendingRequest: false,
          pendingRequestId: null
        });
        this.fetchRequests();
        if (isEditingPendingRequest) {
          this.showSnack('Pending request updated successfully');
        } else if (this.state.tabValue === 0) {
          this.showSnack('Request submitted successfully');
        }
      } else {
        this.showSnack(res.message);
        this.setState({ loading: false });
      }
    } catch (err) {
      console.error(err);
      this.setState({ loading: false });
      this.showSnack('Error submitting request');
    }
  };

  openApprovalDialog = (request) => {
    this.setState({
      approvalDialogOpen: true,
      selectedRequest: request,
      approvalRemarks: ''
    });
  };

  openRejectionDialog = (request) => {
    this.setState({
      rejectionDialogOpen: true,
      selectedRequest: request,
      rejectionRemarks: ''
    });
  };

  handleApprove = async () => {
    const { selectedRequest, approvalRemarks } = this.state;
    this.setState({ loading: true });
    try {
      const res = await approveBusinessUnitRequest({
        request_id: selectedRequest.request_id,
        remarks: approvalRemarks
      });

      if (res.status === 'success') {
        this.setState({ approvalDialogOpen: false, loading: false });
        this.fetchRequests();
        this.fetchBusinessUnits();
        this.showSnack('Request approved successfully');
      } else {
        this.showSnack(res.message);
        this.setState({ loading: false });
      }
    } catch (err) {
      console.error(err);
      this.setState({ loading: false });
      this.showSnack('Error approving request');
    }
  };

  handleReject = async () => {
    const { selectedRequest, rejectionRemarks } = this.state;
    if (!rejectionRemarks) {
      this.showSnack('Remarks are mandatory for rejection');
      return;
    }
    this.setState({ loading: true });
    try {
      const res = await rejectBusinessUnitRequest({
        request_id: selectedRequest.request_id,
        remarks: rejectionRemarks
      });

      if (res.status === 'success') {
        this.setState({ rejectionDialogOpen: false, loading: false });
        this.fetchRequests();
        this.showSnack('Request rejected successfully');
      } else {
        this.showSnack(res.message);
        this.setState({ loading: false });
      }
    } catch (err) {
      console.error(err);
      this.setState({ loading: false });
      this.showSnack('Error rejecting request');
    }
  };

  openEditPendingRequestDialog = (request) => {
    this.setState({
      requestDialogOpen: true,
      formData: {
        business_unit_id: request.business_unit_id,
        label: request.label,
        value: request.value,
        bank_account_number: request.bank_account_number || '',
        is_bu_wise_buf: request.is_bu_wise_buf || false,
        remarks: request.remarks || ''
      },
      isEditingPendingRequest: true,
      pendingRequestId: request.request_id
    });
  };

  openTimeline = (request) => {
    this.setState({
      timelineOpen: true,
      selectedRequest: request
    });
  };

  getBusinessUnitsColumns() {
    const { role } = this.state;
    const canRequestUpdate = ['City Finance', 'root'].includes(role);

    const columns = [
      {
        Header: "ID",
        id: "id",
        accessor: d => d.id,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["id"] }),
        filterAll: true,
        width: 80
      },
      {
        Header: "Label",
        id: "label",
        accessor: d => d.label,
        style: { 'whiteSpace': 'unset', 'wordWrap': 'break-word' },
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["label"] }),
        filterAll: true
      },
      {
        Header: "Value",
        id: "value",
        accessor: d => d.value,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["value"] }),
        filterAll: true
      },
      {
        Header: "Bank Account Number",
        id: "bank_account_number",
        accessor: d => d.bank_account_number || '-',
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["bank_account_number"] }),
        filterAll: true,
        width: 180
      },
      {
        Header: "BU-wise BUF",
        id: "is_bu_wise_buf",
        accessor: d => d.is_bu_wise_buf ? 'Yes' : 'No',
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["is_bu_wise_buf"] }),
        filterAll: true,
        width: 120,
        Cell: ({ value }) => (
          <span style={{
            padding: '4px 8px',
            borderRadius: '4px',
            backgroundColor: value === 'Yes' ? '#4caf50' : '#9e9e9e',
            color: 'white',
            fontSize: '12px'
          }}>
            {value}
          </span>
        )
      }
    ];

    if (canRequestUpdate) {
      columns.push({
        Header: "Actions",
        id: "actions",
        accessor: d => d,
        filterable: false,
        sortable: false,
        width: 180,
        Cell: ({ value }) => (
          <Button
            size="small"
            color="primary"
            onClick={() => this.openUpdateRequestDialog(value)}
          >
            <EditIcon fontSize="small" style={{ marginRight: 5 }} />
            Update Request
          </Button>
        )
      });
    }

    return columns;
  }

  getRequestsColumns() {
    const { role } = this.state;

    const canApprove = (req) => {
      if (req.status !== 'pending') return false;
      return ['Super Central Finance', 'root'].includes(role);
    };

    const canEdit = (req) => {
      if (req.status !== 'pending') return false;
      return ['City Finance', 'root'].includes(role);
    };

    const columns = [
      {
        Header: "ID",
        id: "request_id",
        accessor: d => d.request_id,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["request_id"] }),
        filterAll: true,
        width: 80
      },
      {
        Header: "Type",
        id: "request_type",
        accessor: d => d.request_type,
        style: { textTransform: 'capitalize' },
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["request_type"] }),
        filterAll: true,
        width: 100
      },
      {
        Header: "Label",
        id: "label",
        accessor: d => d.label,
        style: { 'whiteSpace': 'unset', 'wordWrap': 'break-word' },
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["label"] }),
        filterAll: true
      },
      {
        Header: "Value",
        id: "value",
        accessor: d => (businessUnitMap[d.value] && businessUnitMap[d.value].value) || '-',
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["value"] }),
        filterAll: true
      },
      {
        Header: "Bank Account",
        id: "bank_account_number",
        accessor: d => d.bank_account_number || '-',
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["bank_account_number"] }),
        filterAll: true,
        width: 150
      },
      {
        Header: "BU-wise BUF",
        id: "is_bu_wise_buf",
        accessor: d => d.is_bu_wise_buf ? 'Yes' : 'No',
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["is_bu_wise_buf"] }),
        filterAll: true,
        width: 100
      },
      {
        Header: "Requester",
        id: "requester_name",
        accessor: d => d.requester ? d.requester.name : '-',
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["requester_name"] }),
        filterAll: true,
        width: 120
      },
      {
        Header: "Status",
        id: "status",
        accessor: d => d.status,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["status"] }),
        filterAll: true,
        width: 100,
        Cell: ({ value }) => (
          <span style={{
            padding: '4px 8px',
            borderRadius: '4px',
            backgroundColor: value === 'approved' ? '#4caf50' : value === 'rejected' ? '#f44336' : '#ff9800',
            color: 'white',
            fontSize: '12px'
          }}>
            {value ? value.toUpperCase() : 'N/A'}
          </span>
        )
      },
      {
        Header: "Created At",
        id: "created_at",
        accessor: d => moment(d.created_at).format("DD MMM YYYY HH:mm"),
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["created_at"] }),
        filterAll: true,
        width: 150
      },
      {
        Header: "Actions",
        id: "actions",
        accessor: d => d,
        filterable: false,
        sortable: false,
        minWidth: 300,
        Cell: ({ value }) => (
          <div>
            {canEdit(value) && (
              <Button
                onClick={() => this.openEditPendingRequestDialog(value)}
                color="default"
                variant="outlined"
                size="small"
                style={{ marginRight: 5 }}
              >
                <EditIcon fontSize="small" style={{ marginRight: 3 }} />
                Edit
              </Button>
            )}
            {canApprove(value) && (
              <Fragment>
                <Button
                  onClick={() => this.openApprovalDialog(value)}
                  color="primary"
                  variant="outlined"
                  size="small"
                  style={{ marginRight: 5 }}
                >
                  Approve
                </Button>
                <Button
                  onClick={() => this.openRejectionDialog(value)}
                  color="secondary"
                  variant="outlined"
                  size="small"
                  style={{ marginRight: 5 }}
                >
                  Reject
                </Button>
              </Fragment>
            )}
            <Button
              size="small"
              onClick={() => this.openTimeline(value)}
            >
              <HistoryIcon fontSize="small" style={{ marginRight: 3 }} />
              Timeline
            </Button>
          </div>
        )
      }
    ];

    return columns;
  }

  getFilteredRequests() {
    const { requests, tabValue } = this.state;

    if (tabValue === 1) {
      return requests.filter(r => r.status === 'pending');
    }
    return requests;
  }

  renderBusinessUnitsTable() {
    const { businessUnits } = this.state;

    return (
      <ReactTable
        style={{ textAlign: "center", margin: '20px' }}
        data={businessUnits}
        filterable
        defaultFilterMethod={(filter, row) =>
          String(row[filter.id]) === filter.value}
        columns={[{ columns: this.getBusinessUnitsColumns() }]}
        defaultPageSize={10}
        className="-striped -highlight"
        noDataText="No Business Units Found!"
      />
    );
  }

  renderRequestsTable() {
    const filteredRequests = this.getFilteredRequests();

    return (
      <ReactTable
        style={{ textAlign: "center", margin: '20px' }}
        data={filteredRequests}
        filterable
        defaultFilterMethod={(filter, row) =>
          String(row[filter.id]) === filter.value}
        columns={[{ columns: this.getRequestsColumns() }]}
        defaultPageSize={10}
        className="-striped -highlight"
        noDataText="No Requests Found!"
      />
    );
  }

  render() {
    const { role, tabValue, loading, requestDialogOpen, formData, approvalDialogOpen, rejectionDialogOpen, timelineOpen, selectedRequest } = this.state;
    const canCreate = ['City Finance', 'root'].includes(role);

    return (
      <MuiThemeProvider>
        <div>
          <Header />
          <div style={{ padding: 20 }}>
            {canCreate && (
              <Button
                variant="contained"
                color="primary"
                onClick={this.openCreateRequestDialog}
                style={{ marginBottom: 20 }}
              >
                <AddIcon style={{ marginRight: 5 }} />
                Request New Business Unit
              </Button>
            )}

            <Paper style={{ marginBottom: 20 }}>
              <Tabs value={tabValue} onChange={this.handleTabChange} indicatorColor="primary" textColor="primary">
                <Tab label="All Business Units" />
                <Tab label="Pending Requests" />
                <Tab label="All Requests / History" />
              </Tabs>
            </Paper>

            {loading && (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress size={60} thickness={7} />
              </div>
            )}

            {!loading && tabValue === 0 && this.renderBusinessUnitsTable()}
            {!loading && tabValue === 1 && this.renderRequestsTable()}
            {!loading && tabValue === 2 && this.renderRequestsTable()}

            {/* Create/Update Dialog */}
            <Dialog open={requestDialogOpen} onClose={() => this.setState({ requestDialogOpen: false, isEditingPendingRequest: false, pendingRequestId: null })} maxWidth="sm" fullWidth>
              <DialogTitle>
                {this.state.isEditingPendingRequest
                  ? 'Edit Pending Request'
                  : (formData.business_unit_id ? 'Update Business Unit Request' : 'New Business Unit Request')}
              </DialogTitle>
              <DialogContent>
                {this.state.isEditingPendingRequest && (
                  <Paper style={{
                    padding: '10px 15px',
                    marginBottom: '15px',
                    backgroundColor: '#fff3e0',
                    border: '1px solid #ff9800'
                  }}>
                    <Typography variant="body2" style={{ color: '#e65100' }}>
                      <strong>Note:</strong> You are editing an existing pending request (ID: {this.state.pendingRequestId}).
                      Changes will update the pending request instead of creating a new one.
                    </Typography>
                  </Paper>
                )}
                <TextField
                  autoFocus
                  margin="dense"
                  label="Label (Display Name)"
                  fullWidth
                  value={formData.label}
                  onChange={(e) => this.setState({ formData: { ...formData, label: e.target.value } })}
                  placeholder="e.g. Co-Living"
                />
                <TextField
                  margin="dense"
                  label="Value (Key)"
                  fullWidth
                  value={formData.value}
                  onChange={(e) => this.setState({ formData: { ...formData, value: e.target.value } })}
                  placeholder="e.g. coliving"
                  disabled={!!formData.business_unit_id}
                  helperText={formData.business_unit_id ? "Value cannot be changed for existing business units" : "Unique identifier used in the system"}
                />
                <TextField
                  margin="dense"
                  label="Bank Account Number (Debit Account)"
                  fullWidth
                  value={formData.bank_account_number}
                  onChange={(e) => this.setState({ formData: { ...formData, bank_account_number: e.target.value } })}
                  placeholder="Enter bank account number"
                  helperText="This account will be used as Debit Account for BU-wise BUF generation"
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.is_bu_wise_buf}
                      onChange={(e) => this.setState({ formData: { ...formData, is_bu_wise_buf: e.target.checked } })}
                      color="primary"
                    />
                  }
                  label="Enable BU-wise BUF Generation"
                  style={{ 
                    marginTop: 10, 
                    display: 'flex',
                    alignItems: 'center',
                  }}
                />
                {formData.is_bu_wise_buf && (
                  <Paper style={{
                    padding: '10px 15px',
                    marginTop: '5px',
                    marginBottom: '10px',
                    backgroundColor: '#e3f2fd',
                    border: '1px solid #2196f3'
                  }}>
                    <Typography variant="body2" style={{ color: '#1565c0' }}>
                      When enabled, a single consolidated BUF file will be generated for this business unit using the specified bank account, instead of city-wise files.
                    </Typography>
                  </Paper>
                )}
                <TextField
                  margin="dense"
                  label="Remarks"
                  fullWidth
                  multiline
                  rows={3}
                  value={formData.remarks}
                  onChange={(e) => this.setState({ formData: { ...formData, remarks: e.target.value } })}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => this.setState({ requestDialogOpen: false })} disabled={loading}>Cancel</Button>
                <Button onClick={this.handleRequestSubmit} color="primary" disabled={loading}>
                  {loading ? <CircularProgress size={20} thickness={5} /> : 'Submit'}
                </Button>
              </DialogActions>
            </Dialog>

            {/* Approval Dialog */}
            <Dialog open={approvalDialogOpen} onClose={() => this.setState({ approvalDialogOpen: false })} maxWidth="sm" fullWidth>
              <DialogTitle>Approve Request</DialogTitle>
              <DialogContent>
                <Typography gutterBottom>
                  Are you sure you want to approve request for <strong>{selectedRequest ? selectedRequest.label : ''}</strong>?
                </Typography>
                {selectedRequest && (
                  <Paper style={{ padding: '10px 15px', marginBottom: '15px', backgroundColor: '#f5f5f5' }}>
                    <Typography variant="body2"><strong>Label:</strong> {selectedRequest.label}</Typography>
                    <Typography variant="body2"><strong>Value:</strong> {selectedRequest.value}</Typography>
                    <Typography variant="body2"><strong>Bank Account:</strong> {selectedRequest.bank_account_number || 'N/A'}</Typography>
                    <Typography variant="body2"><strong>BU-wise BUF:</strong> {selectedRequest.is_bu_wise_buf ? 'Yes' : 'No'}</Typography>
                  </Paper>
                )}
                <TextField
                  margin="dense"
                  label="Approval Remarks (Optional)"
                  fullWidth
                  multiline
                  rows={3}
                  value={this.state.approvalRemarks}
                  onChange={(e) => this.setState({ approvalRemarks: e.target.value })}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => this.setState({ approvalDialogOpen: false })} disabled={loading}>Cancel</Button>
                <Button onClick={this.handleApprove} color="primary" variant="contained" disabled={loading}>
                  {loading ? <CircularProgress size={20} thickness={5} style={{ color: 'white' }} /> : 'Approve'}
                </Button>
              </DialogActions>
            </Dialog>

            {/* Rejection Dialog */}
            <Dialog open={rejectionDialogOpen} onClose={() => this.setState({ rejectionDialogOpen: false })} maxWidth="sm" fullWidth>
              <DialogTitle>Reject Request</DialogTitle>
              <DialogContent>
                <Typography gutterBottom>
                  Are you sure you want to reject request for <strong>{selectedRequest ? selectedRequest.label : ''}</strong>?
                </Typography>
                <TextField
                  margin="dense"
                  label="Rejection Remarks (Mandatory)"
                  fullWidth
                  multiline
                  rows={3}
                  value={this.state.rejectionRemarks}
                  onChange={(e) => this.setState({ rejectionRemarks: e.target.value })}
                  error={this.state.rejectionRemarks === ''}
                  helperText={this.state.rejectionRemarks === '' ? 'Remarks are required' : ''}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => this.setState({ rejectionDialogOpen: false })} disabled={loading}>Cancel</Button>
                <Button onClick={this.handleReject} color="secondary" variant="contained" disabled={loading}>
                  {loading ? <CircularProgress size={20} thickness={5} style={{ color: 'white' }} /> : 'Reject'}
                </Button>
              </DialogActions>
            </Dialog>

            {/* Timeline Dialog */}
            <BusinessUnitRequestTimeline
              open={timelineOpen}
              requestId={selectedRequest ? selectedRequest.request_id : null}
              onClose={() => this.setState({ timelineOpen: false })}
            />

            {/* Snackbar for notifications */}
            <Snackbar
              open={this.state.snackOpen}
              autoHideDuration={3000}
              onClose={this.handleCloseSnack}
              message={this.state.snackText}
            />
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default BusinessUnitManagement;



// WEBPACK FOOTER //
// ./src/components/BusinessUnitManagement.js